import './polyfills';
import { AvailableLocales } from '@/utils/translations/constants';

export const DEFAULT_LOCALE = AvailableLocales.EN_US;
